import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import qs from 'query-string';

import { Block } from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import Webform from '../../../components/Webform';

import './style.scss';
import { BLOCK_DONATION_BLOCK_ID } from '../../../config/constants';
import WebformHidden from '../../../components/WebformHidden';

const ParagraphDonationForm = ({ entity }) => {
  const history = useHistory();

  // Fetch the query parameters we might have been given
  const queryParams = qs.parse(window.location.search);
  const {
    amount,
    interval,
  } = queryParams;

  const [amountSelected, setAmountSelected] = useState(amount);
  const [intervalSelected, setIntervalSelected] = useState(interval);

  const id = entity.getIn(['field_webform', 0, 'target_id']);
  const title = entity.getIn(['field_title', 0, 'value'], 'aa');

  const overrides = {
    hidden: WebformHidden,
  };

  useEffect(() => {
    const query = qs.stringifyUrl({
      url: window.location.pathname,
      query: {
        amount: amountSelected,
        interval: intervalSelected,
      },
    });
    history.push(query);
  }, [amountSelected, intervalSelected, history]);

  return (
    <Container className="ParagraphDonationForm">

      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <Block
            id={BLOCK_DONATION_BLOCK_ID}
            props={{ title, amountSelected, intervalSelected }}
            setAmountSelected={setAmountSelected}
            setIntervalSelected={setIntervalSelected} />
        </div>
      </div>

      <div className="row">
        <div className="ParagraphDonationForm__inner col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <Webform
            root
            id={id}
            overriddenComponents={overrides}
          />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphDonationForm;
